// Admin URL moves of 2026-10-01: the new admin (src/v2admin) is /rdj-api and
// Classic is /rdj-api/classic until 2026-10-31. Old links keep working:
//   /rdj-api/v2/...        the same page without /v2 (search and hash kept)
//   /rdj-api/video-links   Classic /rdj-api/classic/video-links
//   /rdj-api#<classic tab> Classic /rdj-api/classic#<tab> (search kept), so
//                          old Classic deep links like ?eventId=...#events open
//                          where they used to.
// /rdj-api/events and /rdj-api/reviews now belong to the new admin.

export const ADMIN_BASE = "/rdj-api";
export const CLASSIC_ADMIN_BASE = "/rdj-api/classic";
export const CLASSIC_RETIRES_ON = "2026-10-31";

// The Classic tab hashes (ADMIN_TABS in src/components/admin/AdminPage.js).
export const CLASSIC_TAB_HASHES = [
  "events",
  "availability",
  "portal",
  "reviews",
  "gmail",
  "gallery",
  "videos",
  "gallery-order",
  "audio",
  "equipment",
  "expenses",
  "docs",
  "config",
  "song-requests",
  "lead-log",
  "services",
  "packing",
];

const tail = (loc) => `${loc?.search ?? ""}${loc?.hash ?? ""}`;

// /rdj-api/v2[/rest] to /rdj-api[/rest], search and hash kept.
export function withoutV2(loc) {
  const pathname = String(loc?.pathname ?? "");
  const rest = pathname.replace(/^\/rdj-api\/v2(?=\/|$)/, "");
  const path = rest === pathname ? pathname : `${ADMIN_BASE}${rest}`;
  return `${path.replace(/\/+$/, "") || ADMIN_BASE}${tail(loc)}`;
}

// A Classic tab link at /rdj-api (pathname exactly /rdj-api or /rdj-api/
// with a Classic tab hash): where it lives now. null for anything else.
export function classicHashTarget(loc) {
  const pathname = String(loc?.pathname ?? "");
  if (pathname !== ADMIN_BASE && pathname !== `${ADMIN_BASE}/`) return null;
  const hash = String(loc?.hash ?? "").replace(/^#/, "");
  if (!CLASSIC_TAB_HASHES.includes(hash)) return null;
  return `${CLASSIC_ADMIN_BASE}${tail(loc)}`;
}
